import {
  Component,
  Input,
  Output,
  DoCheck,
  KeyValueDiffers,
  KeyValueDiffer,
  EventEmitter
} from '@angular/core';

import {
  SkyFileItem
} from './file-item';

import {
  SkyFileLink
} from './file-link';


export class SkyFileItemComponent implements DoCheck {
  
  public fileItem: SkyFileItem | SkyFileLink;

  
  public deleteFile = new EventEmitter<SkyFileLink | SkyFileItem>();

  private otherCls: string;
  private differ: KeyValueDiffer<any, any>;

  public constructor(private differs: KeyValueDiffers) {
    this.differ = this.differs.find({}).create(undefined);
  }

  public ngDoCheck() {
    let changes = this.differ.diff(this.fileItem);

    if (changes) {
      let cls: string,
          extensionUpper = this.getFileExtensionUpper(),
          fileTypeUpper: string;

      switch (extensionUpper) {
        case '.PDF':
          cls = 'pdf';
          break;
        case '.GZ':
        case '.RAR':
        case '.TGZ':
        case '.ZIP':
          cls = 'archive';
          break;
        case '.PPT':
        case '.PPTX':
          cls = 'powerpoint';
          break;
        case '.DOC':
        case '.DOCX':
          cls = 'word';
          break;
        case '.XLS':
        case '.XLSX':
          cls  = 'excel';
          break;
        case '.TXT':
          cls = 'text';
          break;
        case '.HTM':
        case '.HTML':
          cls = 'code';
          break;
        default:
          break;
      }

      if (!cls) {
        fileTypeUpper = this.getFileTypeUpper();

        switch (fileTypeUpper.substr(0, fileTypeUpper.indexOf('/'))) {
          case 'AUDIO':
            cls = 'audio';
            break;
          case 'IMAGE':
            // Normally images are displayed as thumbnails, but if an image type is not recognized
            // as being widely supported by modern browsers (e.g. TIFF files) then an icon should
            // be displayed instead.
            cls = 'image';
            break;
          case 'TEXT':
            cls = 'text';
            break;
          case 'VIDEO':
            cls = 'video';
            break;
          default:
            break;
        }
      }
      this.otherCls = 'fa-file-' + (cls ? cls + '-' : '') + 'o';
    }
  }

  public itemDelete() {
    this.deleteFile.emit(this.fileItem);
  }

  public isFile() {
    let file = (<SkyFileItem>this.fileItem).file;

    /* tslint:disable */
    return file && file !== undefined && file !== null && file.size !== undefined
      && file.size !== null;
    /* tslint:enable */
  }

  public isImg() {
    let fileTypeUpper = this.getFileTypeUpper(),
                        slashIndex: number;

    slashIndex = fileTypeUpper.indexOf('/');

    if (slashIndex >= 0) {
      switch (fileTypeUpper.substr(fileTypeUpper.indexOf('/') + 1)) {
        case 'BMP':
        case 'GIF':
        case 'JPEG':
        case 'PNG':
          return true;
        default:
          break;
      }
    }

    return false;
  }

  private getFileExtensionUpper() {
    let extension = '',
        name: string;

    /* istanbul ignore else */
    /* sanity check */
    if (this.fileItem) {
      let file = (<SkyFileItem>this.fileItem).file;
      if (file) {
        /* istanbul ignore next */
        name = file.name || '';
        /* istanbul ignore next */
        extension = name.substr(name.lastIndexOf('.')) || '';
      } else {
        extension = '';
      }

    }

    return extension.toUpperCase();
  }

  private getFileTypeUpper() {
    let fileType = '';
    /* istanbul ignore else */
    /* sanity check */
    if (this.fileItem) {
      let file = (<SkyFileItem>this.fileItem).file;
      if (file) {
        fileType = file.type || '';
      } else {
        fileType = '';
      }
    }

    return fileType.toUpperCase();
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-file-item',
  template: `<div class="sky-file-item">
    <div class="sky-file-item-title">
        <div class="sky-file-item-name-container">
            <div class="sky-file-item-name">
                <strong *ngIf="isFile()">{{fileItem.file.name || fileItem.url}}</strong>
                <strong *ngIf="!isFile()">{{fileItem.url}}</strong>
            </div>
            <div class="sky-file-item-size" *ngIf="isFile()">
                ({{fileItem.file.size | skyFileSize}})
            </div>
        </div>
        <div class="sky-pull-right">
          <button type="button" class="sky-btn sky-btn-default sky-file-item-btn-delete" [attr.aria-label]="'file_item_delete' | skyResources" (click)="itemDelete()">
              <i class="fa fa-lg fa-trash-o"></i>
          </button>
        </div>
    </div>
    <div class="sky-file-item-content">
        <div class="sky-file-item-preview">
            <div *ngIf="isImg()" class="sky-file-item-preview-img-container">
              <img class="sky-file-item-preview-img" [src]="fileItem.url" />
            </div>
            <div *ngIf="!isImg()" class="sky-file-item-preview-other">
                <i class="fa" [ngClass]="otherCls"></i>
            </div>
        </div>
        <div class="sky-file-item-content-custom">
          <ng-content></ng-content>
        </div>
    </div>
</div>
`,
  styles: [`.sky-file-item {
  border-top: 1px solid #e2e3e4;
  border-bottom: 1px solid #e2e3e4;
  border-left: 1px solid #e2e3e4;
  border-right: 1px solid #e2e3e4;
  background-color: #eeeeef;
  padding: 10px;
  margin-bottom: 10px;
}

.sky-file-item-name-container {
  display: inline-block;
  width: 85%;
}

.sky-file-item-name {
  white-space: nowrap;
  overflow: hidden;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
}

.sky-file-item-title {
  margin-bottom: 10px;
}

.sky-file-item-content {
  display: flex;
}

.sky-file-item-preview {
  flex-basis: 25%;
}

.sky-file-item-content-custom {
  flex-basis: 75%;
}

.sky-file-item-preview-img-container {
  text-align: center;
}

.sky-file-item-preview-img {
  max-width: 100%;
  height: auto;
  box-shadow: 0 0 5px #666;
}

.sky-file-item-preview-other {
  color: #686c73;
  font-size: 100px;
  line-height: 1;
  text-align: center;
  width: 100%;
}
`]

}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: KeyValueDiffers, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'fileItem': [{ type: Input },],
'deleteFile': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
